import { render, staticRenderFns } from "./InternalManagementForm.vue?vue&type=template&id=03568c8c"
import script from "./InternalManagementForm.vue?vue&type=script&lang=js"
export * from "./InternalManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports